<script setup lang="ts">
import { computed } from 'vue';

import ThemedButton from '@/components/base/ThemedButton.vue';
import BaseBodyText from '@/components/base/typography/BaseBodyText.vue';
import Header2 from '@/components/base/typography/Header2.vue';
import { OnsiteOfferQuizConfig } from '@/data/quiz/onsiteOffer';

const { initialScreen } = defineProps<{
  initialScreen: NonNullable<OnsiteOfferQuizConfig['initialScreen']>;
}>();

const emit = defineEmits<{
  'cta-clicked': [];
  close: [];
}>();

const backgroundImageDesktop = computed(() => `url('${initialScreen.mainImageDesktopSrc}')`);
const backgroundImageMobile = computed(() => `url('${initialScreen.mainImageMobileSrc}')`);
</script>

<template>
  <div class="flex flex-col-reverse items-center justify-center sm:flex-row">
    <div class="flex-1 px-6 pb-12 text-center sm:pb-12 sm:text-left">
      <img :src="initialScreen.logoImageSrc" class="hidden h-16 sm:visible sm:block" alt="" />
      <Header2 class="mt-14">{{ initialScreen.headline }}</Header2>
      <BaseBodyText class="mt-6 font-bold sm:mt-9">
        {{ initialScreen.caption }}
      </BaseBodyText>
      <ThemedButton class="w-full mt-6 sm:mt-9" theme="gray" @click="emit('cta-clicked')">
        {{ initialScreen.buttonCta }}
      </ThemedButton>
      <ThemedButton class="w-full mt-4" theme="white" @click="emit('close')">
        No thanks! I’d like to pay full price
      </ThemedButton>
    </div>
    <div
      class="flex-1 w-full h-full pt-52 sm:pt-[73%] bg-center bg-no-repeat bg-cover dynamic-bg"
    />
  </div>
</template>

<style scoped>
.dynamic-bg {
  background-image: v-bind(backgroundImageMobile);
}
@media (min-width: 768px) {
  .dynamic-bg {
    background-image: v-bind(backgroundImageDesktop);
  }
}
</style>
